import PropTypes from "prop-types";
import MDBox from "components/MDBox";

// Logos imports
import uberLogo from "assets/images/UBER.png";
import boltLogo from "assets/images/BOLT.svg";
import heetchLogo from "assets/images/HEETCH.webp";
import freenowLogo from "assets/images/FREENOW.jpeg";

// Mapping des logos et couleurs de fond
const platformData = {
  uber: {
    logo: uberLogo,
    backgroundColor: "#000000",
  },
  bolt: {
    logo: boltLogo,
    backgroundColor: "#FFFFFF",
  },
  heetch: {
    logo: heetchLogo,
    backgroundColor: "#FFFFFF",
  },
  freenow: {
    logo: freenowLogo,
    backgroundColor: "#FFFFFF",
  },
};

function PlatformIcon({ platform }) {
  const data = platformData[platform.toLowerCase()] || platformData.uber;

  return (
    <img
      src={data.logo}
      alt={`${platform} logo`}
      style={{
        width: "100%",
        height: "100%",
        objectFit: "cover",
        display: "block",
      }}
    />
  );
}

// Typechecking props
PlatformIcon.propTypes = {
  platform: PropTypes.oneOf(["uber", "bolt", "heetch", "freenow"]).isRequired,
};

export default PlatformIcon;
